<template>
    <div>
        <Tree
            :items="tree"
            :activeIds="breadcrumbIds"
            :showItemCount="false"
            :showToplevelFlag="true"
            :showSubitemFlag="false"
            @itemClick="setSelectedLotteries"
        />
    </div>
</template>

<script>
    import StoreUtil from '@app/store/StoreUtil';
    import Tree from 'src/terminal/app/modules/shared/components/tree/Tree';

    export default {
        name: 'LotteryFilterContainer',
        props: {
            lottoNamespace: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...StoreUtil.mapGettersDynamic('lottoNamespace', [
                'tree',
                'breadcrumbIds',
            ]),
        },
        methods: {
            ...StoreUtil.mapActionsDynamic('lottoNamespace', [
                'setSelectedLotteries'
            ]),
        },
        components: {
            Tree,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/lotto/LotteryFilterContainer.vue